import script from "./TabCampos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabCampos.vue?vue&type=script&setup=true&lang=js"

import "./TabCampos.vue?vue&type=style&index=0&id=7800e978&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7800e978"]])

export default __exports__